import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-outside" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "desc-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "font-title" }, "非アクティブユーザーの請求書発行 ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-desc" }, "社員番号", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inactiveUserId) = $event)),
          class: "date-input"
        }, null, 512), [
          [_vModelText, _ctx.inactiveUserId]
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToInactiveUser && _ctx.goToInactiveUser(...args))),
          class: "select-button"
        }, " 進める ")
      ])
    ])
  ]))
}